module.exports = __webpack_public_path__ + "static/media/pwaLogo.ee62cb58.webp";